/* Woodcraftees — "Find My Size" pill next to the Size label.
   Opens the NATIVE size chart (snippets/wc-size-chart.liquid, rendered once per product page from
   layout/theme.liquid) — chart picked by product type, no app limit. Replaced the Mageplaza/Avada app
   modal on 2026-09-26 (free plan = 3 charts). Fallback: if the native dialog is missing, the click is
   still forwarded to the app's parked inline button, exactly as before. Our pill lives in
   product-variant-picker.liquid, so Dawn's variant re-render keeps it; listeners are delegated. */
(function () {
  function dialog() { return document.getElementById('wc-size-chart'); }
  function appButton() { return document.querySelector('.mp-inline-button .Avada-inline-button'); }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.wc-find-size');
    if (pill) {
      e.preventDefault();
      var d = dialog();
      if (d && typeof d.showModal === 'function') { d.showModal(); document.documentElement.classList.add('wc-sc-open'); return; }
      var btn = appButton();
      if (btn) btn.click();
      return;
    }
    var d2 = dialog();
    if (!d2 || !d2.open) return;
    // close on the X, or on a click on the backdrop (the dialog element itself, outside its content)
    if (e.target.closest('.wc-sc__close') || e.target === d2) d2.close();
  });
  // Scroll lock follows the dialog's 'open' attribute. Not the 'close' event: it never fired on the live
  // PDP (tested 2026-09-26), which left the page stuck on overflow:hidden after closing.
  var d0 = dialog();
  if (d0 && window.MutationObserver) {
    new MutationObserver(function () {
      document.documentElement.classList.toggle('wc-sc-open', d0.hasAttribute('open'));
    }).observe(d0, { attributes: true, attributeFilter: ['open'] });
  }

  if (dialog()) { document.documentElement.classList.add('wc-has-sizechart'); return; }
  var tries = 0;
  (function detect() {
    if (dialog() || appButton()) { document.documentElement.classList.add('wc-has-sizechart'); return; }
    if (++tries < 40) setTimeout(detect, 250);
  })();
})();


/* Woodcraftees — carry the chosen SIZE across the style pills (theme-tweaks/size-carry.js) */
(function () {
  var PARAM = 'wc_size';
  var picked = null;                   // only a size the customer actually pressed

  function sizeInputs() {
    return [].slice.call(document.querySelectorAll('input[type="radio"][name^="Size"]'));
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][name^="Size"]')) picked = t.value;
  });

  // rewrite the pill href at click time, in the capture phase, so a variant re-render
  // between choosing a size and tapping a style cannot leave a stale link behind
  document.addEventListener('click', function (e) {
    if (!picked || !e.target || !e.target.closest) return;
    var pill = e.target.closest('a.wc-style-pill');
    if (!pill) return;
    var href = pill.getAttribute('href');
    if (!href) return;
    try {
      var u = new URL(href, location.origin);
      u.searchParams.set(PARAM, picked);
      pill.setAttribute('href', u.pathname + (u.search || '') + (u.hash || ''));
    } catch (err) { /* leave the link exactly as it was */ }
  }, true);

  // destination: select that size if it exists here, then drop the param
  function applyIncoming() {
    var want = null;
    try { want = new URLSearchParams(location.search).get(PARAM); } catch (err) { return; }
    if (!want) return;

    var hit = sizeInputs().filter(function (i) { return i.value === want && !i.disabled; })[0];
    if (hit && !hit.checked) {
      var sel;
      try { sel = 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(hit.id) : hit.id) + '"]'; } catch (err) { sel = null; }
      var lab = sel ? document.querySelector(sel) : null;
      if (lab) lab.click();
      else { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
      picked = want;
    }
    // no match -> nothing selected, on purpose

    try {
      var u = new URL(location.href);
      u.searchParams.delete(PARAM);
      history.replaceState({}, '', u.pathname + (u.search || '') + (u.hash || ''));
    } catch (err) { /* cosmetic only */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyIncoming);
  else applyIncoming();
})();
